"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SameActorType = void 0;
const ActorType_1 = require("../actors/ActorType");
exports.SameActorType = {
    [ActorType_1.ActorType.Necromancer]: [ActorType_1.ActorType.NecromancerMale],
    [ActorType_1.ActorType.NecromancerMale]: [ActorType_1.ActorType.Necromancer],
    [ActorType_1.ActorType.Warrior]: [ActorType_1.ActorType.WarriorJoe],
    [ActorType_1.ActorType.WarriorJoe]: [ActorType_1.ActorType.Warrior]
};
